var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C6.04462 0 0 6.04378 0 13.5C0 20.9554 6.04462 27 13.5 27C20.9554 27 27 20.9554 27 13.5C27 6.04378 20.9554 0 13.5 0ZM9.99337 18.7962H7.23937V10.5106H9.99337V18.7962ZM8.61637 9.37912H8.59865C7.6739 9.37912 7.07653 8.74209 7.07653 7.94728C7.07653 7.13475 7.69247 6.51628 8.63409 6.51628C9.57572 6.51628 10.1562 7.13475 10.1739 7.94728C10.1739 8.74293 9.57572 9.37912 8.61637 9.37912ZM19.9235 18.7962H17.1695V14.3632C17.1695 13.2494 16.7712 12.49 15.7739 12.49C15.0137 12.49 14.5606 13.0022 14.3615 13.4975C14.2889 13.6747 14.2703 13.9219 14.2703 14.1691V18.7962H11.5172C11.5172 18.7962 11.5535 11.2885 11.5172 10.5106H14.2712V11.6842C14.6365 11.1198 15.2913 10.3157 16.7535 10.3157C18.565 10.3157 19.9235 11.5003 19.9235 14.0451V18.7962Z",
    fill: "#F6901F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup23);
export default __webpack_public_path__ + "static/media/Group (23).1e59d5075641d7f4b351990a7b5c58f4.svg";
export { ForwardRef as ReactComponent };